export enum ProfileStatus {
	VERIFIED = 1,
	MODERATING = 2,
	PREMODERATING = 3,
	BLOCKED = 11,
	DELETED = 21,
	NOPASSPORTDATA = 31,
}
